import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data";
import { Reveal } from "@/components/Reveal";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const move = (d) => setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section data-testid="testimonials-section" className="bg-cream py-24 md:py-40">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-terracotta mb-10">
            (Guest notes)
          </p>
        </Reveal>

        <Reveal delay={0.05}>
          <Quote size={44} strokeWidth={1} className="text-mist mx-auto mb-8" />
        </Reveal>

        <div className="min-h-[240px] md:min-h-[220px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              data-testid="testimonial-quote"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <p className="font-serif text-2xl sm:text-3xl md:text-4xl leading-snug text-charcoal">
                &ldquo;{t.quote}&rdquo;
              </p>
              <footer className="mt-8 font-sans">
                <span className="block text-charcoal font-medium tracking-wide">{t.name}</span>
                {t.place && (
                  <span className="block text-sm text-charcoal/50 uppercase tracking-[0.2em] mt-1">{t.place}</span>
                )}
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          <button
            data-testid="testimonial-prev"
            onClick={() => move(-1)}
            className="w-11 h-11 rounded-full border border-charcoal/20 flex items-center justify-center text-charcoal hover:bg-charcoal hover:text-cream transition-all duration-300"
            aria-label="Previous review"
          >
            <ArrowLeft size={17} strokeWidth={1.5} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                data-testid={`testimonial-dot-${idx}`}
                onClick={() => setI(idx)}
                className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-terracotta" : "w-1.5 bg-charcoal/25"}`}
                aria-label={`Go to review ${idx + 1}`}
              />
            ))}
          </div>
          <button
            data-testid="testimonial-next"
            onClick={() => move(1)}
            className="w-11 h-11 rounded-full border border-charcoal/20 flex items-center justify-center text-charcoal hover:bg-charcoal hover:text-cream transition-all duration-300"
            aria-label="Next review"
          >
            <ArrowRight size={17} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </section>
  );
};
